import React from "react";
import ReactApexChart from "react-apexcharts";
import { ApexOptions } from "apexcharts";
import { useAppSelector } from "../../../store/hooks";

const FiredEmployeesRatio = () => {
  const dashboardState = useAppSelector(
    (state) => state.dashboard.dashboardData,
  );
  const state = {
    series: [
      {
        name: "Employees",
        data: dashboardState.currentYearFinalExit,
      },
    ],
    options: {
      chart: {
        height: 350,
        type: "area", // Use 'area' type for area chart
        zoom: {
          enabled: false,
        },
        toolbar: {
          show: false,
        },
      },
      dataLabels: {
        enabled: true,
      },
      stroke: {
        curve: "straight",
      },
      title: {
        text: "Fired Employees Current Year",
        align: "center",
        style: {
          fontSize: "20px",
          fontWeight: "600",
          fontFamily: "Poppins",
          color: "#000000",
        },
      },
      colors: ["#FFD300"],
      grid: {
        xaxis: {
          lines: {
            show: true,
          },
        },
        yaxis: {
          lines: {
            show: true,
          },
        },
      },
      xaxis: {
        title: {
          text: "Months",
          style: {
            cssClass: "apex-chart-side-heading",
          },
        },
        categories: [
          "Jan",
          "Feb",
          "Mar",
          "Apr",
          "May",
          "Jun",
          "Jul",
          "Aug",
          "Sep",
          "Oct",
          "Nov",
          "Dec",
        ],
      },
      yaxis: {
        title: {
          text: "Employees",
          style: {
            cssClass: "apex-chart-side-heading",
          },
        },
        labels: {
          formatter: function (val) {
            return val.toFixed(0);
          },
        },
      },
      fill: {
        colors: ["#FFD300"], // Specify the fill color
        // Specify the fill opacity
      },
    } as ApexOptions,
  };

  return (
    <div className="section px-4 py-4 mb-4">
      <ReactApexChart
        options={state.options}
        series={state.series}
        type="area"
        height={350}
      />
    </div>
  );
};

export default FiredEmployeesRatio;
